import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { DataCollectorService } from '../data_collector_services/data_collector_service.service';

@Injectable({
    providedIn: 'root'
})
export class CustomersService {
    get customerUrl(): string{
        return `${this.dataCollectorService.baseurl()}/customers/`;
    }
    get paymentsUrl(): string{
        return `${this.dataCollectorService.baseurl()}/payments/customers/`;
    }
    get paymentProviderUrl(): string{
        return `${this.dataCollectorService.baseurl()}/payments/provider`;
    }
    get customerAPIUrls(): any{
        return {
            propertyUrl: `${this.dataCollectorService.baseurl()}/property`,
            serviceContractUrl: `${this.dataCollectorService.baseurl()}/service_contract`,
            assetsUrl: `${this.dataCollectorService.baseurl()}/assets`,
            recurringJobsUrl: `${this.dataCollectorService.baseurl()}/recurring_jobs`,
            transactionsUrl: `${this.dataCollectorService.baseurl()}/payments/transactions`,
            dataUrl : `${this.dataCollectorService.baseurl()}/v2/customers/filter`,
            columnUrl: `${this.dataCollectorService.baseurl()}/v2/customers/meta`,
            filterUrl: `${this.dataCollectorService.baseurl()}/v2/customers/meta/filter`,
            bulkActionUrl: `${this.customerUrl}bulk_action`,
            invoiceUrl: `${this.dataCollectorService.baseurl()}/invoice`,
            estimateUrl: `${this.dataCollectorService.baseurl()}/estimate`,
            sendsmsUrl: `${this.dataCollectorService.baseurl()}/estimate`,
            mergeCustomerUrl: `${this.dataCollectorService.baseurl()}/customers/merge`,
            outboundUrl: `${this.dataCollectorService.baseurl()}/outbound_logs`,
            newCustomer: `${this.dataCollectorService.baseurl()}/customers_new`,
            projectUrl: `${this.dataCollectorService.baseurl()}/projects`,
            requestUrl: `${this.dataCollectorService.baseurl()}/request`
        };
    }

    customerDetailsLoaded: Subject<boolean> = new Subject<boolean>();
    currentCustomerDetails = new BehaviorSubject<any>(null);
    selectedOrganizationPropertyPickerFilterValue = new BehaviorSubject<any>(null);

    constructor(private dataCollectorService: DataCollectorService) {
        this.customerDetailsLoaded.next(false);
     }


    activationURl(customerId: string): string{
        return `${this.customerUrl}${customerId}/activation`;
      }
    getCustomerUrl(customerId: string): string {
        return `${this.customerUrl}${customerId}`;
    }

    getCustomerCatgeory(): string {
        return `${this.customerUrl}category`;
    }

    getPaymentCardsUrl(customerId: string): string {
        return `${this.paymentsUrl}${customerId}/cards`;
    }

    getCustomerNotesUrl(customerId: string): string {
        return `${this.customerUrl}${customerId}/note`;
    }
    deleteURL(customerId: string): string{
        return `${this.customerUrl}${customerId}`;
    }
    getPaymentCards(customerId: string): any{
        const paymentURL= `${this.paymentsUrl}${customerId}/cards`;
        return this.dataCollectorService.getData(paymentURL);
    }

    getSendSmsEmailUrl(customerId: string): string{
        const paymentURL= `${this.getCustomerUrl(customerId)}/send`;
        return paymentURL;
    }

    getOutboundLogDetailsUrl(logId): string{
        return `${this.dataCollectorService.baseurl()}/outbound_logs/${logId}`;
    }

    getBillingFrequency(): string {
        return this.customerUrl + 'billing_frequency';
    }

    getPaymentTerms(): string {
        return this.dataCollectorService.baseurl() + '/invoices/payment_terms';
    }

    getTaxGroups(): string {
        return this.dataCollectorService.baseurl() + '/invoice_estimate/tax_groups';
    }

    getPriceList(): string {
        return this.dataCollectorService.baseurl() + '/products/pricelist';
    }

    getCardIntentUrl(customerUID): string{
        return `${this.paymentsUrl}${customerUID}/card_intent`;
    }

    getAccountsUrl(customerUID: string): string{
        return `${this.dataCollectorService.baseurl()}/customers/${customerUID}/accounts`;
    }

    getTaxEntitiesUrl(): string {
        return this.dataCollectorService.baseurl() + '/taxes/entity_use_codes';
    }
    performBulkAction(payload): Observable<any>{
        const url = `${this.customerUrl}bulk_action`;
        return this.dataCollectorService.postData(url,payload);
      }
    getPropertyAssociationUrl(customerUID: string): string {
        return `${this.dataCollectorService.baseurl()}/customers/${customerUID}/associations`;
    }
}
